import jwt from 'jsonwebtoken'
import moment from 'moment'

export const generateToken = () => {
  if (process.env.NODE_ENV !== 'test') {
    return jwt.sign({ date: moment().toISOString() }, process.env.NEXT_PUBLIC_UUID || '')
  }
}
